module.exports = __webpack_public_path__ + "static/media/logo-full.c227cdba.svg";